var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{staticClass:"blank-page",attrs:{"breadCrumb":_vm.breadCrumb}},[_c('div',{staticClass:"queryView"},[_c('div',{staticClass:"title"},[_vm._v("欢迎来到控客后台服务")]),_c('img',{staticClass:"image",attrs:{"src":require("@/assets/images/bg.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }